import useAddresses from '../Hooks/useAddresses';

const AddressList = () => {
    const { addresses, loading, error } = useAddresses();
  
    if (loading) {
      return <p className="text-center text-gray-500">Loading addresses...</p>;
    }
  
    if (error) {
      return <p className="text-center text-red-500">Failed to load addresses: {error.message}</p>;
    }
  
    if (addresses.length === 0) {
      return <p className="text-center text-gray-500">No addresses found.</p>;
    }
  
    return (
      <div className="container mx-auto p-4">
        {/* <h2 className="text-2xl font-bold text-center mb-4">Address List</h2> */}
        <table className="table-auto w-full border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              {/* <th className="px-4 py-2 border">ID</th>
              <th className="px-4 py-2 border">User</th> */}
              <th className="px-4 py-2 border text-xs">Address Type</th>
              <th className="px-4 py-2 border text-xs">Address</th>
              <th className="px-4 py-2 border text-xs">City</th>
              <th className="px-4 py-2 border text-xs">Postal Code</th>
               {/*<th className="px-4 py-2 border text-xs">Default</th>
              <th className="px-4 py-2 border">Created At</th>
              <th className="px-4 py-2 border">Updated At</th> */}
            </tr>
          </thead>
          <tbody>
            {addresses.map((address) => (
              <tr key={address.id} className="hover:bg-gray-50">
                {/* <td className="px-4 py-2 border text-center">{address.id}</td>
                <td className="px-4 py-2 border text-center">{address.user}</td> */}
                <td className="px-4 py-2 border text-center text-xs">{address.address_type}</td>
                <td className="px-4 py-2 border text-xs w-100">{address.address}</td>
                <td className="px-4 py-2 border text-xs w-40">{address.city}</td>
                <td className="px-4 py-2 border text-center text-xs">{address.postal_code}</td>
                {/* <td className="px-4 py-2 border text-center text-xs">{address.is_default ? "Yes" : "No"}</td>
                <td className="px-4 py-2 border text-center">{new Date(address.created_at).toLocaleString()}</td>
                <td className="px-4 py-2 border text-center">{new Date(address.updated_at).toLocaleString()}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  
  export default AddressList;